import { compose } from '../system';
import { Colors, colors, type ThemeColors } from './colors';
import { type Space, space, type ThemeSpace } from './space';

export { ThemeColors, ThemeSpace };

export type PropsApi = Colors & Space;
export type { MarginProps, PaddingProps } from './space';

export const styleProps = compose(colors, space);
